import controller from './exports.controller';

const template = require('./exports.html');

export default {
    controller,
    template
};
